<mat-dialog-content (keydown)="onKeyDown()" class="dialog-calendar">
  <header class="dialog-calendar-header" *ngIf="isMobile">
    <app-icon-button
      [isOutline]="false"
      label="Close calendar"
      icon="close"
      buttonId="close-dialog-availability-button"
      backgroundColor="var(--roller-neutral-95)"
      (action)="closeDialog()"></app-icon-button>
  </header>

  <app-calendar-availability
    [currentDate]="currentDate"
    [availabilityData]="availabilityData"
    [isDataVisible]="isDataVisible"
    [showBestPrice]="showBestPrice"
    #appCalendar
    (dateSelected)="onDateSelected($event)"
    (calendarActiveDate)="checkForMonthChange($event)" />

  <div class="availability-legend">
    <ng-container *ngIf="!isDataVisible; else showFullKey">
      <div class="availability-legend__container">
        <span class="legend unavailable"></span>
        <span>{{ 'CALENDAR.UNAVAILABLE' | translate }}</span>
      </div>
    </ng-container>
    <ng-template #showFullKey>
      <div class="availability-legend__container">
        <span class="legend online-sales-closed"></span>
        <span>
          {{ (isCallToBookEnabled ? 'SALES_CLOSED.CALL_TO_BOOK' : 'SALES_CLOSED.SALES_CLOSED') | translate }}
        </span>
      </div>
      <div *ngIf="!showBestPrice" class="availability-legend__container">
        <span class="legend lots-space"></span>
        <span>{{ 'CALENDAR.LOTS_OF_SPACE' | translate }}</span>
      </div>
      <div *ngIf="!showBestPrice" class="availability-legend__container">
        <span class="legend filling-fast"></span>
        <span>{{ 'CALENDAR.FILLING_UP_FAST' | translate }}</span>
      </div>
      <div class="availability-legend__container">
        <span class="legend unavailable"></span>
        <span>{{ 'CALENDAR.UNAVAILABLE' | translate }}</span>
      </div>
      <div class="availability-legend__container">
        <span class="legend sold-out"></span>
        <span>{{ 'GENERIC.SOLD_OUT' | translate }}</span>
      </div>
    </ng-template>
  </div>
</mat-dialog-content>
